
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Divider from 'vux/src/components/divider/index.vue'


export default {
components: {
XHeader,
Tab,
TabItem,
Divider
},
data () {
return {
tabIndex:0,
pathCur:0,
model:{appPatchId : this.$route.query.appPatchId},
list:{},

}
},
created(){

this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mpaas/detail/getPatchDetail',this.model,{emulateJSON:true}).then(function(res){

if(res.body.success)
{
this.list=res.body.rows;
if(this.list.appPatchDesc !=undefined){
this.list.appPatchDesc=  this.list.appPatchDesc.replace(/style="[^"]*?"/g,'');
this.list.appPatchDesc= this.list.appPatchDesc.replace(/height="[^"]*?"/g,'');
this.list.appPatchDesc= this.list.appPatchDesc.replace(/width="[^"]*?"/g,'');
this.list.appPatchDesc= this.list.appPatchDesc.replace(/img/g,'img width="100%" ');
}
}
},function(res){
console.log(res.status);
});
},
methods: {

}
}



// WEBPACK FOOTER //
// ./src/views/mall/paas/patchdetail.vue